var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"yogo-select",domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event.target.value)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }